import { memo } from 'react';
import { UserRegister4Template } from 'components/templates/UserRegister4Template';

type Props = {};

export const UserRegister4Page = memo((_props: Props) => {
	return <UserRegister4Template />;
});
